<app-copilot-analysis #analysis
                      (findingSelected)="onFindingSelected($event)"
                      (clearSelected)="onClearSelected()"></app-copilot-analysis>
<app-monaco-editor [options]="editorOptions"
                   (onInit)="onEditorInit($event)"></app-monaco-editor>